import styled from 'styled-components'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'

export const Wrapper = styled(FlexWrapper)<any>`
  ${props => props.isLivBrite && `
    li { font-size: 16px; }
  `}

  > div {
    max-width: unset;
    margin: 0;
    border: none;

    > div {
      padding: 5px;
    }
  }

  li {
    &:not(:first-of-type) {
      color: ${props => props.theme.palette.general.strong};
      font-weight: normal;
    }
  }
`
